import AdminSelectForm from '~/components/scheduling/AdminSelectForm.jsx';
import EditFormAdminScheduling from '~/components/scheduling/EditFormAdminScheduling.jsx';
import { useState } from 'react';

const AdminSelectAndEditForm = ({
    formId,
    setFormId,
    answers,
    setAnswers,
    eventTypeId,
}) => {
    const [showEditForm, setShowEditForm] = useState(false);

    return (
        <>
            <AdminSelectForm
                formId={formId}
                setFormId={setFormId}
                eventTypeId={eventTypeId}
            />

            <div className="mt-2 flex justify-end">
                <button
                    type="button"
                    className="link text-sm !no-underline"
                    onClick={() => setShowEditForm(true)}
                >
                    Edit Form Fields
                </button>
            </div>
            <EditFormAdminScheduling
                isOpen={showEditForm}
                onClose={() => setShowEditForm(false)}
                answers={answers}
                setAnswers={newAnswers =>
                    setAnswers(old =>
                        typeof newAnswers === 'function'
                            ? newAnswers(old)
                            : newAnswers,
                    )
                }
                formId={formId}
                eventTypeId={eventTypeId}
            />
        </>
    );
};

export default AdminSelectAndEditForm;
